import { render, staticRenderFns } from "./AddAdminForm.vue?vue&type=template&id=e0295e58&scoped=true&"
import script from "./js/add-admin-form.js?vue&type=script&lang=js&"
export * from "./js/add-admin-form.js?vue&type=script&lang=js&"
import style0 from "./AddAdminForm.vue?vue&type=style&index=0&id=e0295e58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0295e58",
  null
  
)

export default component.exports